import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { 
  LucideAngularModule, 
  Home, 
  Droplet, 
  ChartColumnIncreasing, 
  Settings, 
  BadgeDollarSign, 
  Users, 
  TestTube, 
  Pill, 
  Stethoscope, 
  FileText, 
  DollarSign, 
  Boxes, 
  ArrowDownUp, 
  SearchCheck, 
  Siren, 
  Microscope, 
  Rss, 
  MessageSquare,
  Printer,
  ChartArea,
  TabletSmartphone,
  ShieldCheck,
  Sparkles,
  FileCode,
  FileSpreadsheet,
  Braces,
  LoaderCircle
} from 'lucide-angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { LayoutModule } from './layout/layout.module';
import { DebugConsoleComponent } from './shared/components/debug-console/debug-console.component';
import { ToastComponent } from './shared/components/toast/toast.component';
import { PwaInstallBannerComponent } from './shared/components/pwa-install-banner/pwa-install-banner.component';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    CoreModule,
    SharedModule,
    LayoutModule,
    AppRoutingModule,
    ToastComponent,
    DebugConsoleComponent,
    PwaInstallBannerComponent,
    LucideAngularModule.pick({
      Home,
      Droplet,
      ChartColumnIncreasing,
      Settings,
      BadgeDollarSign,
      Users,
      TestTube,
      Pill,
      Stethoscope,
      FileText,
      DollarSign,
      Boxes,
      ArrowDownUp,
      SearchCheck,
      Siren,
      Microscope,
      Rss,
      MessageSquare,
      Printer,
      ChartArea,
      TabletSmartphone,
      ShieldCheck,
      Sparkles,
      FileCode,
      FileSpreadsheet,
      Braces,
      LoaderCircle
    }),
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
